module.exports = __webpack_public_path__ + "static/logo_primary-8f867bfac878ea180f73aacf606f9cb3.svg";